import axios from '@/plugins/http/axios.js';
import config from "@/views/reports/config/reports.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);

export const service = {

    getListReports : (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/report`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },
    
    getListStartMonetizations: (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/monetization-report/monetization/data`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getListConfirmMonetizations: (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/monetization-report`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getEmailSend: (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/report/user/email`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    generateMonetizationReport: (idGroup,idEmpresa, idUsuario, isDownload) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/monetization-report/create/report/?isDownload=${isDownload}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    postConfirmMonetizations: (idGroup,idEmpresa, idUsuario, document ) => {
        return axios({
            method: 'post',
            url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/monetization-report/confirm`,
            headers:{
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario 
            },
            data: document,
            redirect: 'follow'
        })
    },

    postHistoricMonetization: (idGroup, idEmpresa, idUsuario, data ) => {
        return axios({
            method: 'post',
            url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/monetization-report/history`,
            headers:{
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario 
            },
            data: data,
            redirect: 'follow'
        })
    },
};
